'use strict';

var _ = require('lodash');
var GridRemoveSpecialEventButtonController = function GridRemoveSpecialEventButtonController($scope, specialEventsGridService, momentConstants, featureToggleService, seasonalityConstants) {
  var gridPanel = $scope.gridPanelScope;
  $scope.isRemoveSpecialEventsShown = false;
  $scope.selectedRows = [];
  $scope.onRowSelection = function (selectedRows, selectedRowIndexes) {
    $scope.isRemoveSpecialEventsShown = selectedRows.length > 0 && _.every(selectedRows, function (element) {
      return element.isRowRemovable;
    });
    $scope.selectedRows = selectedRows;
    $scope.selectedRowIndexes = selectedRowIndexes;
  };
  function getSpecialEventKey(specialEvent) {
    return specialEvent.market + specialEvent.eventName + specialEvent.eventType + (specialEvent.startDate ? specialEvent.startDate.format(momentConstants.FORMATS.DATE_ISO) : '') + (specialEvent.endDate ? specialEvent.endDate.format(momentConstants.FORMATS.DATE_ISO) : '');
  }
  $scope.removeSpecialEvent = function () {
    var loadedData = gridPanel.localData;
    var selectedKeys = $scope.selectedRows.map(function (row) {
      return getSpecialEventKey(row);
    });
    var removedUserExclusionEvents = _.chain(loadedData).remove(function (row) {
      return _.includes(selectedKeys, getSpecialEventKey(row));
    }).filter(specialEventsGridService.isUserExclusionEvent).value();
    gridPanel.updateData(loadedData);
    if (_.isFunction($scope.removeEventsCallback)) {
      $scope.removeEventsCallback(removedUserExclusionEvents);
    }
    if (featureToggleService.isEnabled('POOLED_SEASONALITY') && $scope.calendarModeLabel === seasonalityConstants.CALENDAR_MODES.DEMAND) {
      var movingEventsNewlyAdded = _.filter(gridPanel.localData, {
        isRowRemovable: true
      });
      var isSaveSpecialEventShow = movingEventsNewlyAdded.length > 0;
      $scope.$emit('pooled-seasonality-special-events:showSpecialEventsFromParent', isSaveSpecialEventShow);
    }
  };
};
GridRemoveSpecialEventButtonController.$inject = ['$scope', 'SpecialEventsGridService', 'MomentConstants', 'FeatureToggleService', 'SeasonalityConstants'];
module.exports = GridRemoveSpecialEventButtonController;